var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sfe-header-more",
      class: _vm.noTitle ? "flex-end" : "flex-between",
    },
    [
      !_vm.noTitle
        ? _c("h4", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))])
        : _vm._e(),
      _vm._v(" "),
      !_vm.noMore
        ? _c(
            "el-button",
            {
              staticClass: "button",
              attrs: { type: "text", size: "medium" },
              on: { click: _vm.clickMoreBtn },
            },
            [
              _vm._v("\n    " + _vm._s(_vm.$t("common.more")) + "\n    "),
              _c("i", { staticClass: "el-icon-arrow-right" }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }